export type ReportInstrument = {
  family: string;
  number: number;
  name: string;
  percussion: boolean;
};

export type ReportControlChange = {
  number: number;
  count: number;
};

export type TrackReport = {
  index: number;
  channel: number;
  instrument: ReportInstrument;
  hasNotes: boolean;
  noteCount: number;
  programChangeCount: number;
  controlChanges: ReportControlChange[];
  pitchBendCount: number;
  metaCount: number;
  unknownMetaCount: number;
};

export type ReportTempo = {
  bpm: number;
  ticks: number;
};

export type ReportTimeSignature = {
  value: string;
  ticks: number;
};

export type ReportKeySignature = {
  key: string;
  scale: "major" | "minor";
  ticks: number;
};

export const MIN_CONFIDENCE = 0.5;

export type DetectedKey = {
  key: string;
  scale: "major" | "minor";
  confidence: number;
} | null;

export type KeyDetection = {
  best: DetectedKey;
  alternatives: DetectedKey[];
  noteCount: number;
};

export type Report = {
  fileName: string;
  duration: string;
  durationTicks: number;
  tempos: ReportTempo[];
  timeSignatures: ReportTimeSignature[];
  keySignatures: ReportKeySignature[];
  detectedKey: KeyDetection;
  tracks: TrackReport[];
};